export const IconPinMapsNavigation20: {
  name: 'icon_pin_maps_navigation_20-7f2e8abcaa57'
} = {
  name: 'icon_pin_maps_navigation_20-7f2e8abcaa57'
}
